<template>
  <div>
    <div
      v-if="isURL(image)"
      class="message ma-1"
      style="position:relative;border-radius: 12px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
      :style="{
        float: align,
        width: width
      }"
    >
      <div style="font-size: 12px;color:black; line-height: 0;margin-top: 0">
        <img :src="image" alt style="width: 100%" />
      </div>

      <div style="height: 100%; position: absolute; top: 0; right: 0; left: 0; bottom: 0">
        <v-layout justify-center align-center row style="height: 100%">
          <div class="text-xs-center">
            <v-btn small fab color="#00000059" dark @click="showImage">
              <v-icon>search</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>
    </div>
    <div
      v-else-if="image.includes('base64,')"
      class="message ma-1"
      style="position:relative;border-radius: 12px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;"
      :style="{
        float: align,
        width: width
      }"
    >
      <div style="font-size: 12px;color:black; line-height: 0;margin-top: 0">
        <img :src="image" alt style="width: 100%" />
      </div>

      <div style="height: 100%; position: absolute; top: 0; right: 0; left: 0; bottom: 0">
        <v-layout justify-center align-center row style="height: 100%">
          <div class="text-xs-center">
            <v-btn small fab color="#00000059" dark @click="showImage">
              <v-icon>search</v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>
    </div>
    <div
      class="message"
      v-else
      style="position:relative;border-radius: 12px;max-width: 181px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;margin-bottom: 5px;    white-space: initial;"
      :style="{ float: align }"
    >
      <div style="font-size: 12px;" :style="{ color: 'black' }">
        <div style="padding: 5px 8px 6px;" :style="{ 'background-color': 'grey' }">
          <span style="line-height:15.36px; line-height: 22px;">
            <!-- <template v-if="value.contentProvider.type == 'line'"></template> -->
            <template v-if="image != ''">
              <specialtext :text="image"></specialtext>
            </template>
            <template v-else>-</template>
          </span>
        </div>
      </div>
    </div>

    <v-dialog v-model="showPreviewImage" max-width="600">
      <v-card v-if="image">
        <div class="text-xs-right">
          <v-btn fab small flat @click="showPreviewImage = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <!-- <product-zoomer :base-images="previewImage" :base-zoomer-options="zoomerOptions" /> -->
          <img :src="image" style="width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import ProductZoomer from 'vue-product-zoomer'
import specialtext from '@/components/elements/specialtext'
import config from '@/config'
import { mapGetters } from 'vuex'

export default {
  props: ['value', 'width', 'align'],
  data() {
    return {
      image: '',
      showPreviewImage: false,

      zoomerOptions: {
        zoomFactor: 4,
        pane: 'container',
        hoverDelay: 300,
        namespace: 'inline-container',
        move_by_click: false,
        scroll_items: 7,
        choosed_thumb_border_color: '#dd2c00',
        scroller_position: 'right'
      },
      previewImage: null
    }
  },
  components: {
    specialtext
    // ProductZoomer
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    let url = null
    try {
      if (this.isURL(this.value)) {
        url = this.value
      } else if (this.value.includes('base64,')) {
        url = this.value
      } else {
        let val = JSON.parse(this.value)
        if (val && val.contentProvider && val.contentProvider.type == 'line') {
          if (val.id) {
            url =
              config.serverUrl +
              `line/content/image/${this.$store.state.livechat.pageid}/${val.id}${
                this.selectedBot.line_modular_botid
                  ? `?line_modular_botid=${this.selectedBot.line_modular_botid}`
                  : ''
              }`
          }
        }
      }
    } catch (error) {
      console.log(error)
      url = this.value
    }
    this.image = url || this.value
    this.previewImage = [
      {
        // required
        normal_size: [{ id: 1, url: this.value }]
      }
    ]
  },

  methods: {
    async showImage() {
      await this.$nextTick()
      this.showPreviewImage = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ImageType.vue